














































import {Vue, Component, Ref, Prop, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {ImportZonesItem, TarificationTransports, TarificationTypes} from "@/store/tarification/types";
import {SelectWings} from "wings-ui-components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError} from "@/utils/notify-helper";
import Swal from "sweetalert2";
import {getTranslatedParams} from "@/utils/notify-utils";
import {ActionLog} from "@/store/auth/types";

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportTariffZones extends Vue {
  @PropSync('show') is_show!: boolean;
  @PropSync('partner_id') partnerId!: number|undefined;
  @PropSync('operator_id') operatorId!: number|undefined;
  @Prop() transport!: TarificationTransports;
  @Prop() type!: TarificationTypes;
  @Ref('validator') validator: any;
  @Action("importTariffZones") actionImport: any;
  @Action("actionLog") actionLog: any;
  @Getter delimiterList:any;

  private importRequest:ImportZonesItem = {
    name:undefined,
    file:undefined,
    delimiter:','
  };

  public resetData(): void {
    this.importRequest.name = undefined;
    this.importRequest.file = undefined;
  }

  private logObject: ActionLog = {};

  onFileUpload (evt:any) {
    this.importRequest.file = evt[0]
  }

  async importZones():Promise<void> {
    let valid:boolean = await this.validator.validate();
    if (valid) {
      try {
        let readPromise = new Promise<any>((resolve, reject) => {
          let fr = new FileReader();
          fr.onerror = reject;
          fr.onload = () => resolve(fr.result);
          fr.readAsText(this.importRequest.file);
        });
        let string = await readPromise;
        let object;
        if (this.partnerId) {
          object = {
            partner_id: this.partnerId,
            transport: this.transport,
            item: {
              name: this.importRequest.name,
              file: btoa(string),
              delimeter: this.importRequest.delimiter === 'space' ?  ' ' : this.importRequest.delimiter
            },
          }
        } else if (this.operatorId) {
          object = {
            operator_id: this.operatorId,
            transport: this.transport,
            item: {
              name: this.importRequest.name,
              file: btoa(string),
              delimeter: this.importRequest.delimiter === 'space' ?  ' ' : this.importRequest.delimiter
            },
          }
        }
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Tariff zone",
          addititional_info: getTranslatedParams(object)
        }
        let response:any = await this.actionImport(object);
        await this.actionLog(this.logObject);
        Swal.fire({
          type: 'success',
          title: <string> this.$t('import_success'),
          confirmButtonClass: "md-button md-success",
          html: '<div>'+
              '<p>'+this.$t('added_zones_count') + ': '+response?.data?.added_zones_count+'</p>'+
              '<p>'+this.$t('edited_zones_count') + ': '+response?.data?.edited_zones_count+'</p>'+
              '<p>'+this.$t('failed_zones_count') + ': '+response?.data?.failed_zones_count+'</p>'+
              '</div>',
          showConfirmButton: true
        });
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        if (error.response.data.message === 'File parse error: fields mismatch') {
          Swal.fire({
              type: 'error',
              title: <string> this.$t('import_error'),
              confirmButtonClass: "md-button md-success",
              html: <string> this.$t('invalid_file'),
              showConfirmButton: true
          });
        } else {
          notifyError(error);
        }
      }
    } else {
      setTimeout(() => {
        notifyError(null, this.validator.errors)
      }, 100);
    }
  }
}
